"use strict";
/**
 * API Route Constants
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = exports.API_BASE = void 0;
exports.API_BASE = "/api";
exports.ROUTES = {
    AUTH: `/auth`,
    COMMANDS: `${exports.API_BASE}/commands`,
    CONFIGS: `${exports.API_BASE}/configs`,
    DISCORD: `${exports.API_BASE}/discord`,
    ME: `${exports.API_BASE}/me`,
    PRAC: `${exports.API_BASE}/prac`,
    STREAM_ALERTS: `${exports.API_BASE}/streamAlerts`,
    STREAMS: `${exports.API_BASE}/streams`,
    TEST_EVENTS: `${exports.API_BASE}/testEvents`,
    TWITCH: `${exports.API_BASE}/twitch`,
    WEB: `${exports.API_BASE}/web`,
};
//# sourceMappingURL=constants.js.map